import type { QueueBreakNode } from '../../types';
import { cva } from 'class-variance-authority';
import type { PropsWithChildren } from 'react';
import { useFormatTaskDuration } from '../../hooks';
import { useCustomTranslation } from '../../../../../../hooks';
import { toggleNodeBreakDrawer, useIsOpenNodeBreakDrawer } from './NodeBreakDrawer';

type NodeBreakProps = {
  node: QueueBreakNode;
};

export const breakNodeVariants = cva(
  'relative box-border flex h-11 min-w-11 shrink-0 cursor-pointer items-center rounded-xs border border-border-primary-darker bg-surface-break px-2.5 py-2 transition-all ease-in-out hover:bg-surface-break-hover',
  {
    variants: {
      isOpen: {
        true: 'bg-surface-break-focus',
      },
    },
  },
);

export const NodeBreak = ({ node, children }: PropsWithChildren<NodeBreakProps>) => {
  const formatTaskDuration = useFormatTaskDuration({ compact: true });
  const { t } = useCustomTranslation('common');

  const drawerProps = useIsOpenNodeBreakDrawer();
  const isOpen = drawerProps?.node?.id === node.id;

  return (
    <div
      className={breakNodeVariants({ isOpen })}
      style={{ width: `${node.nodeWidth}px` }}
      onClick={() => toggleNodeBreakDrawer({ node })}
    >
      <div className="flex h-full items-center truncate rounded-xs border border-border-primary-darker bg-surface-primary px-2 text-s11-sb text-text-status-grey-darker uppercase">
        <span className="truncate">
          {t('common.break')} {formatTaskDuration(node)}
        </span>
      </div>
      {children}
    </div>
  );
};

NodeBreak.displayName = 'NodeBreak';
